import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { environment } from "src/environments/environment";
import { ItemState, loadingStart, loadingStop, setItem } from "../../model/custom/Utils";
import { SetReferrer } from "./referrer.actions";
export class ReferrerStateModel {
	public referrer?: ItemState<string>;
}

const defaults = {
	referrer: undefined,
};

@State<ReferrerStateModel>({
	name: "referrer",
	defaults,
})
@Injectable()
export class ReferrerState {
	@Selector()
	public static getReferrer(state: ReferrerStateModel) {
		return state.referrer?.item;
	}

	@Action(SetReferrer)
	public setReferrer(
		ctx: StateContext<ReferrerStateModel>,
		{ payload }: { payload: string | undefined },
	) {
		const { referrer } = ctx.getState();

		loadingStart(ctx, { referrer });
		setItem(ctx, { referrer }, payload);
		loadingStop(ctx, { referrer });
		window.location.href = environment.companyHelpPath;
	}
}
